import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { treatmentPlanV3Actions } from '../../../../../../store';
import useTreatmentPlanV3TreatmentPageState from './useTreatmentPlanV3TreatmentPageState';

import type { AppDispatch } from '../../../../../../store';
import type { TreatmentPlanV3TreatmentPagePayload } from '../../../../../../store/treatmentPlanV3';

export default function useTreatmentPlanV3Treatment() {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();
  const { treatmentPlanId } = useParams<'treatmentPlanId'>();
  const pageState = useTreatmentPlanV3TreatmentPageState();

  const updatePage = useCallback(
    async (data: TreatmentPlanV3TreatmentPagePayload) => {
      if (!treatmentPlanId) return false;
      const result = await dispatch(
        treatmentPlanV3Actions.updateTreatmentPlanV3TreatmentPage({
          treatmentPlanId,
          data,
          getAccessTokenSilently,
        }),
      );
      return treatmentPlanV3Actions.updateTreatmentPlanV3TreatmentPage.fulfilled.match(result);
    },
    [dispatch, getAccessTokenSilently, treatmentPlanId],
  );

  return { ...pageState, updatePage };
}
